// extracted by mini-css-extract-plugin
module.exports = {"readonly":"styles_readonly__bXCMY","container":"styles_container__FatK0"};